<template>
    <b-container>
        <Loading :active.sync="Loading"></Loading>
        <div class="controles">
            <h2>Listado de ventas abiertas</h2>
            <b-button  type="button" variant="secondary" class="volver" href="/home/formulario-ventas" >Volver a solicitud de trabajo</b-button>
        </div>
        <List v-if="ventas" :items="ventas" :fields="fields" :urls="urls" />
        <h2 v-else >No existe ventas para este usuario.</h2>
    </b-container>   
</template>

<script>
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'
    import {mapActions, mapState, mapGetters} from 'vuex'
    import List from '@/components/vendedor/List'
    export default {
        name:'listado',
        components:{
            Loading, List
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState(['Loading']),
            ...mapState('vendedor',['ventas']),
            ...mapState('login',['id']),
            ...mapState('urls',['urls'])
        },
        data:function () {
            return{
                fields:[
                    {key:'id', label:'Folio'},
                    {key:'cliente', label:'Cliente'},
                    {key:'producto', lable:'Producto'},
                    {key:'cantidad', label:'Cantidad'},
                    {key:'trabajo', label:'Trabajo'},
                    {key:'otro', label:'Otro'},
                    {key:'fecha', label:'Fecha'},
                    {key:'hora', label:'Hora'},
                    {key:'solicitante', label:'Solicitante'},
                    {key:'url', label:'Link de archivo'},
                    {key:'observaciones',label:'Observaciones'},
                    {key:'status',label:'Estado'},
                    ]
            }            
        },
        methods:{
            ...mapActions({
                _fetchVentasForSeller: 'vendedor/fetchVentasForSeller',
                 _fetchUrls: 'urls/fetchUrls'
            }),
            init(){

                this._fetchVentasForSeller(this.id)
                 this._fetchUrls()
            }
        }
        
    }
</script>

<style lang="scss" scoped>
.controles{
    display:flex;
    margin-top:1em;
    align-items: center;
}
h2{
    align-self:center;
}

.volver{
    margin-left:1em;
}
@media screen and (max-width: 576px) {
    .controles{
        flex-direction: column;
        padding:0;
        margin:0;
        
    }
}
</style>